// extracted by mini-css-extract-plugin
export default {"overlay":"ImagePreview_overlay__4Pgmj","content":"ImagePreview_content__FomG2"};